import { Checkbox, FormControl, FormLabel, Text } from "@chakra-ui/react";
import { memo, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import { FlowNodeWithChildren } from "./FlowNode";

interface PlayerMoveToLocation extends NodeData {
  waitForPlayer: boolean;
}

function PlayerMoveToLocationNode(props: NodeProps<NodeType<PlayerMoveToLocation>>) {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const waitForPlayer = nodeData?.waitForPlayer ?? false;

  const { register, handleSubmit } = useForm<PlayerMoveToLocation>({
    defaultValues: useMemo(
      () => ({
        waitForPlayer,
      }),
      [waitForPlayer]
    ),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(updateNodeData)} onBlur={handleSubmit(updateNodeData)}>
        <FormControl>
          <FormLabel>
            <Text color={color} casing={"uppercase"}>
              Wait For Move
            </Text>
          </FormLabel>
          <Checkbox color={color} {...register("waitForPlayer")} />
        </FormControl>
      </form>
    </FlowNodeWithChildren>
  );
}

export default memo(PlayerMoveToLocationNode);
